function VisualScript() {
  return (
    <div className="p-10 w-full">
      <div className="flex gap-1.5 mb-5">
        {[0, 1, 2].map(i => (
          <span key={i} className="w-2.5 h-2.5 rounded-full bg-ds-border-mid inline-block" />
        ))}
      </div>
      <div className="flex gap-2.5 mb-5 flex-wrap">
        {['Hook', 'Intro', 'Desarrollo', 'CTA'].map((t, i) => (
          <span
            key={t}
            className={`font-display font-bold text-[10px] tracking-[0.10em] uppercase px-2.5 py-[5px] rounded-sharp border ${
              i === 0
                ? 'bg-ds-text text-ds-bg border-ds-text'
                : 'bg-transparent text-ds-muted border-ds-border-mid'
            }`}
          >
            {t}
          </span>
        ))}
      </div>
      <div className="flex flex-col gap-[9px]">
        {[
          ['85%', 'red'],
          ['100%', 'red'],
          ['70%', 'red'],
          ['100%', ''],
          ['90%', ''],
          ['85%', ''],
          ['55%', ''],
          ['100%', ''],
          ['70%', ''],
        ].map(([w, type], i) => (
          <div
            key={i}
            className={`h-[9px] rounded-[1px] ${i === 3 ? 'mt-2' : ''}`}
            style={{ width: w, background: type === 'red' ? 'rgba(212,43,30,0.30)' : '#282828' }}
          />
        ))}
      </div>
    </div>
  )
}

function VisualStats() {
  const bars = [
    { label: 'Tono conversacional', pct: '88%', red: true },
    { label: 'Vocabulario propio', pct: '75%', red: false },
    { label: 'Estructura narrativa', pct: '92%', red: false },
  ]
  return (
    <div className="p-10 w-full">
      <div className="mb-6">
        <div className="font-display font-black text-[64px] tracking-tight2 leading-none text-ds-text">
          98<span className="text-[20px] text-ds-red font-bold">%</span>
        </div>
        <div className="font-display font-bold text-label tracking-caption uppercase text-ds-muted mt-1">
          Retención de voz personal
        </div>
      </div>
      <div className="flex flex-col gap-3 mt-5">
        {bars.map(({ label, pct, red }) => (
          <div key={label}>
            <div className="font-display font-bold text-label tracking-btn uppercase text-ds-muted mb-[5px]">
              {label}
            </div>
            <div className="h-[5px] bg-ds-border-mid rounded-[1px] overflow-hidden">
              <div
                className={`h-full rounded-[1px] ${red ? 'bg-ds-red' : 'bg-ds-text'}`}
                style={{ width: pct }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

function VisualKanban() {
  const cols = [
    { label: 'Idea', cards: [false, false] },
    { label: 'Guion', cards: [true] },
    { label: 'Grabar', cards: [false, false] },
    { label: 'Publicar', cards: [true] },
  ]
  return (
    <div className="p-8 w-full">
      <div className="font-display font-bold text-label tracking-[0.14em] uppercase text-ds-muted mb-4">
        Pipeline activo — 6 proyectos
      </div>
      <div className="flex gap-2">
        {cols.map(({ label, cards }) => (
          <div
            key={label}
            className="flex-1 bg-ds-elevated border border-ds-border-mid rounded-sharp p-2.5"
          >
            <div className="font-display font-bold text-[10px] tracking-caption uppercase text-ds-muted mb-2 pb-2 border-b border-ds-border">
              {label}
            </div>
            {cards.map((accent, i) => (
              <div
                key={i}
                className={`bg-ds-surface border border-ds-border rounded-sharp p-2 ${i < cards.length - 1 ? 'mb-1.5' : ''}`}
              >
                <div
                  className="h-[7px] rounded-[1px] mb-1"
                  style={{ background: accent ? 'rgba(212,43,30,0.25)' : '#282828' }}
                />
                <div className="h-[7px] w-[60%] bg-ds-border rounded-[1px]" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

const FEATURES = [
  {
    overline: 'Tu voz, capturada una vez',
    title: ['No suena a IA.', 'Suena a ti.'],
    body: 'Configuras tu perfil una vez — proyecto, audiencia, tono, frases típicas — y cada guion se genera desde ese contexto. No pierdes 30 minutos escribiendo prompts. No editas 2 horas para quitar el AI-slop.',
    details: [
      'Perfil persistente — el AI no te olvida entre sesiones como ChatGPT',
      'Regenera cualquier sección sin tirar el resto del guion',
      'Claude Sonnet 4.6 con prompts optimizados para YouTube',
    ],
    Visual: VisualScript,
    reverse: false,
  },
  {
    overline: 'Dicta en vez de escribir',
    title: ['De tu voz,', 'al guion.'],
    body: 'Habla mientras conduces, caminas o paseas al perro. Transcripción en tiempo real, convertida en contexto para el AI. El software desaparece. Queda la creatividad.',
    details: [
      'Transcripción de voz directamente al editor',
      'Tus notas se convierten en input del siguiente guion',
      'Con API key propia (BYOK): generación ilimitada',
    ],
    Visual: VisualStats,
    reverse: true,
  },
  {
    overline: 'Una app, no cinco',
    title: ['Todo en uno.', 'Sin caos.'],
    body: 'De la idea al vídeo publicado sin saltar entre 4 pestañas. Kanban, calendario, analytics de YouTube, B-Roll cinematográfico y publicación en LinkedIn. Lo que antes eran 5 herramientas, ahora es un único ritmo.',
    details: [
      'Idea → Plan → Grabar → Editar → Analizar → Publicar',
      '13 tipos de escena B-Roll cinematográfico con Remotion',
      'Analytics de YouTube + publicación LinkedIn en la misma app',
    ],
    Visual: VisualKanban,
    reverse: false,
  },
]

export function Features() {
  return (
    <section id="funcionalidades">
      {FEATURES.map(({ overline, title, body, details, Visual, reverse }, i) => (
        <div
          key={i}
          className="flex flex-col lg:flex-row border-b border-ds-border lg:min-h-[480px]"
        >
          {/* Text */}
          <div
            className={`flex-1 flex flex-col justify-center px-5 sm:px-8 py-12 lg:px-16 lg:py-[72px] ${
              reverse ? 'order-2 lg:order-2 lg:border-l' : 'order-2 lg:order-1 lg:border-r'
            } border-ds-border`}
          >
            <p className="font-display font-bold text-label tracking-label uppercase text-ds-red mb-4">
              {overline}
            </p>
            <h2 className="font-display font-black text-display-sm tracking-tight1 uppercase text-ds-text mb-5">
              {title[0]}
              <br />
              {title[1]}
            </h2>
            <p className="font-sans text-[14px] text-ds-muted leading-[1.75] max-w-[360px] mb-8">
              {body}
            </p>
            <div className="flex flex-col gap-2.5">
              {details.map(d => (
                <div key={d} className="flex items-start gap-2.5">
                  <span className="font-display font-bold text-ds-red opacity-50 flex-shrink-0 mt-px">
                    —
                  </span>
                  <span className="font-sans text-[13px] text-ds-muted leading-[1.55]">{d}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Visual */}
          <div
            className={`flex-1 bg-ds-surface flex items-center justify-center overflow-hidden min-h-[280px] lg:min-h-0 ${
              reverse ? 'order-1 lg:order-1' : 'order-1 lg:order-2'
            }`}
          >
            <Visual />
          </div>
        </div>
      ))}
    </section>
  )
}
